export const ethnicities = [
  "American Indian",
  "Asian",
  "African American",
  "Hispanic",
  "Native Hawaiian",
  "White",
];
export const languagesPopular = [
  "English",
  "Spanish",
  "Chinese",
  "Tagalog",
  "Vietnamese",
  "French",
  "Arabic",
  "Korean",
  "Russian",
  "German",
];
//to do, a list of every conceivable language when someone complains about this
export const languagesAll = [""];
export const parentRelations = [
  "Father",
  "Mother",
  "Adoptive Parent",
  "Grandparent",
  "Other Relative",
  "Legal Guardian",
  "Foster Parent",
];
export const gender = ["Male", "Female", "Non-binary"];

export const timeSpans = [
  'Last Week',
  'This Week',
  'Next Week',
  'Last Month',
  'This Month',
  'Next Month',
  'Last Quarter',
  'This Quarter',
  'Next Quarter',
  'Last Year',
  'This Year',
  'Next Year',
  'Last School Week',
  'This School Week',
  'Next School Week',
  'Last School Year',
  'This School Year',
  'Next School Year',
  'Custom'
]
//==============================================================================
  //Page Layout stuff.  Put all Enums in src/utils/constants?  Probably.
  //==============================================================================
export const paperSizesEnum = Object.freeze({
  Letter: {
    pageHeight: 11,
    pageWidth: 8.5
  },
  Legal: {
    pageHeight: 14,
    pageWidth: 8.5
  },
  Ledger: {
    pageHeight: 17,
    pageWidth: 11
  },
  Custom: {
    pageHeight: 11,
    pageWidth: 8.5
  }
})

export const pageMarginsEnum = Object.freeze({
  Normal: {
    marginTop: 0.5,
    marginBottom: 0.5,
    marginLeft: 0.5,
    marginRight: 0.5
  },
  Narrow: {
    marginTop: 0.25,
    marginBottom: 0.25,
    marginLeft: 0.25,
    marginRight: 0.25
  },
  Wide: {
    marginTop: 0.75,
    marginBottom: 0.75,
    marginLeft: 0.75,
    marginRight: 0.75
  },
  Custom: {
    marginTop: 0.5,
    marginBottom: 0.5,
    marginLeft: 0.5,
    marginRight: 0.5
  }
})

export const fontNamesEnum = Object.freeze({
  //Specific to jsPDF?
  Courier: 'courier',
  Helvetica: 'Helvetica',
  TimesRoman: 'times-roman'
})

export const fontStylesEnum = Object.freeze({
  //Specific to jsPDF?
  Bold: 'bold',
  BoldItalic: 'bolditalic',
  BoldOblique: 'boldoblique',
  Italic: 'italic',
  Normal: 'normal',
  Oblique: 'oblique',
  Roman: 'roman'
})
